export default {
  errors: {
    COMMON: 'Terjadi Kesalahan',
    NOT_FOUND: 'Tidak Ditemukan',
    NO_INTERNET: 'Tidak ada koneksi internet',
    INTERNAL_SERVER_ERROR: 'Internal Server Error',
    EMAIL_NOT_REGISTERED: 'Email belum terdaftar, silahkan hubungi admin',
    EMAIL_ALREADY_USED: 'Email sudah digunakan, silahkan gunakan yang lain',
    NO_ACCESS: 'Anda tidak punya akses untuk membuka halaman ini',
  },
  validation: {
    UNIQUE_CHARACTER: 'Karakter unik tidak diperbolehkan',
    EMAIL: 'Format email yang digunakan salah',
    PASSWORD: 'Silahkan masukkan password anda',
    PASSWORD_AGAIN: 'Silahkan masukkan kembali kata sandi anda',
    PASSWORD_NOT_MATCH: 'Kata sandi tidak cocok!',
    PASSWORD_NOT_SIX: 'Panjang kata sandi harus minimal 6 karakter',
    USERNAME: 'Silahkan masukkan nama Anda',
    REQUIRED: (field) => `${field} wajib diisi`,
    IMAGE_TOO_LARGE: 'Ukuran gambar tidak boleh lebih dari 500kb.',
    EMPTY: 'Beberapa kolom harus diisi',
    PHONE_NUMBER: 'Format no telp yang digunakan salah',
    NAME: 'Format nama yang digunakan salah, tidak boleh menggunakan angka . / ; [ ] - ',
    ALIAS: 'Format Alias/Inisial yang digunakan salah, tidak boleh menggunakan angka . / ; [ ] - ',
  },
};
